export const ODDS_MARKET_KEYS = ["hdc", "ou", "x2"];

const MIN_SELECTED = 2;
const MAX_SELECTED = 3;

function toBooleans(state) {
  return {
    hdc: Boolean(state.hdc),
    ou: Boolean(state.ou),
    x2: Boolean(state.x2),
  };
}

function selectedCount(flags) {
  return [flags.hdc, flags.ou, flags.x2].filter(Boolean).length;
}

/** Đảm bảo luôn trong [2, 3] lựa chọn (mặc định cả 3 nếu dữ liệu lạ). */
export function normalizeOddsDisplayToggles(state) {
  const flags = toBooleans(state);
  const n = selectedCount(flags);
  if (n === MIN_SELECTED || n === MAX_SELECTED) {
    return { hdc: flags.hdc, ou: flags.ou, x2: flags.x2 };
  }
  if (n === 0) {
    return { hdc: true, ou: true, x2: true };
  }
  // n === 1: bật thêm một loại theo thứ tự HDP → O/U → 1x2
  const next = { ...flags };
  const firstOff = ODDS_MARKET_KEYS.find((k) => !next[k]);
  if (firstOff) next[firstOff] = true;
  return next;
}

/**
 * Bật/tắt một loại kèo: luôn giữ 2–3 loại đang bật.
 */
export function computeOddsMarketClick(prev, key) {
  if (!ODDS_MARKET_KEYS.includes(key)) {
    return { next: prev, warning: null };
  }

  const flags = { ...toBooleans(prev) };
  const on = selectedCount(flags);
  const isOn = flags[key];

  if (isOn) {
    if (on <= MIN_SELECTED) {
      return {
        next: flags,
        warning: `Cần hiển thị tối thiểu ${MIN_SELECTED} tỷ lệ`,
      };
    }
    return {
      next: { ...flags, [key]: false },
      warning: null,
    };
  }

  if (on >= MAX_SELECTED) {
    return {
      next: flags,
      warning: `Chỉ hiển thị tối đa ${MAX_SELECTED} tỷ lệ`,
    };
  }
  return {
    next: { ...flags, [key]: true },
    warning: null,
  };
}

export function getOrderedActiveMarkets({ hdc, ou, x2 }) {
  const ordered = [];
  if (hdc) ordered.push("hdc");
  if (ou) ordered.push("ou");
  if (x2) ordered.push("x2");
  return ordered;
}

export function normalizeDreamnOddsTrend(trend) {
  if (trend == null || trend === "") return "unchanged";
  if (typeof trend === "number") {
    if (trend === 1) return "increased";
    if (trend === 2 || trend === -1) return "decreased";
  }
  const t = String(trend).toLowerCase().trim();
  if (t === "up" || t === "increased" || t === "1") return "increased";
  if (t === "down" || t === "decreased" || t === "2") return "decreased";
  if (t === "unchanged") return "unchanged";
  return "unchanged";
}
